/** Keys of the rooms counter in step 3 "Umfang". */
export enum ERoom {
  BATHROOM = 'bathroom',
  GUEST_WC = 'guest-wc',
  KITCHEN = 'kitchen',
  LIVING = 'living',
  BEDROOM = 'bedroom',
  STUDY = 'study',
  HALLWAY = 'hallway',
  BASEMENT = 'basement'
}
